import { isEmptyArray } from '@app/utils'

export class ObservableService {
  private readonly subscribersMap = new Map<string, Array<(...args: any) => void>>()

  protected subscribe<ArgsType extends unknown[]>(key: string, subscriber: (...args: ArgsType) => void): void {
    const subscribers = this.subscribersMap.get(key) ?? []
    const newSubscribers = [...subscribers, subscriber]

    this.subscribersMap.set(key, newSubscribers)
  }

  protected unsubscribe<ArgsType extends unknown[]>(key: string, subscriber: (...args: ArgsType) => void): void {
    const subscribers = this.subscribersMap.get(key) ?? []
    const filteredSubscribers = subscribers.filter(item => item !== subscriber)

    if (isEmptyArray(filteredSubscribers)) {
      this.subscribersMap.delete(key)
    } else {
      this.subscribersMap.set(key, filteredSubscribers)
    }
  }

  protected broadcast<ArgsType = unknown>(key: string, ...args: ArgsType[]): void {
    const subscribers = this.subscribersMap.get(key)

    subscribers?.forEach(subscriber => subscriber(...args))
  }
}
